import { TabsContent } from "@/components/ui/tabs";
import PlansManagement from "@/components/super-admin/PlansManagement";
import AppsManagement from "@/components/super-admin/AppsManagement";
import AccountsManagement from "@/components/super-admin/AccountsManagement";
import OfficesManagement from "@/components/super-admin/OfficesManagement";
import UsersManagement from "@/components/super-admin/UsersManagement";
import OverviewTab from "@/components/super-admin/OverviewTab";
import UsageAnalytics from "@/components/super-admin/UsageAnalytics";
import McpUsagePanel from "@/components/super-admin/McpUsagePanel";

const TabsContentWrapper = () => {
  return (
    <>
      <TabsContent value="overview">
        <OverviewTab />
      </TabsContent>

      <TabsContent value="offices">
        <OfficesManagement />
      </TabsContent>

      <TabsContent value="users">
        <UsersManagement />
      </TabsContent>

      <TabsContent value="accounts">
        <AccountsManagement />
      </TabsContent>

      <TabsContent value="plans">
        <PlansManagement />
      </TabsContent>

      <TabsContent value="apps">
        <AppsManagement />
      </TabsContent>

      <TabsContent value="usage">
        <UsageAnalytics />
      </TabsContent>

      <TabsContent value="mcp-usage">
        <McpUsagePanel />
      </TabsContent>
    </>
  );
};

export default TabsContentWrapper;
